module.exports = __webpack_public_path__ + "img/Herring-Gull.9ebe329e.png";